import { mapDTO } from '@twistezo/ts-dto-mapper'

import { AdUnitSizeDTO } from 'features/globalSetup/features/viewport'
import { adUnitSizeToDTO } from 'features/globalSetup/features/viewport/utils'
import { floatPercentToDTO, secondsToMilliseconds } from 'utils/number'
import {
  MediaTypeRefresherAttributesSchema,
  MediaTypeRefresherViewportAttributeSchema,
  Schema,
} from '../../schema'
import { MediaTypeRefresherAttributesInput, Variables } from './types'

type From = Schema

type To = Variables

const mediaTypeRefresherToDTO = (
  attribute: MediaTypeRefresherAttributesSchema | MediaTypeRefresherViewportAttributeSchema,
): MediaTypeRefresherAttributesInput => ({
  ...(attribute.id ? { id: attribute.id } : {}),
  additionalSizes: attribute.additionalSizes.map(
    (size: string): AdUnitSizeDTO => adUnitSizeToDTO(size),
  ),
  removeSizes: attribute.removeSizes.map((size: string): AdUnitSizeDTO => adUnitSizeToDTO(size)),
  ...(attribute.viewportId ? { viewportId: attribute.viewportId } : {}),
})

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((from: From): To => {
    const { id, refresherEnabled, refreshRedirect } = from

    const { mediaTypeRefreshers, sendRefreshRequestToExternalAdUnitEnabled, targetAdUnitPath } =
      refreshRedirect

    const {
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold,
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval,
      mobileAdThreshold,
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval,
    } = from.basicSettings

    const ignoreViewportRefresherAttributes = mediaTypeRefreshers.kind === 'default'

    return {
      adUnitId: id,
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold: floatPercentToDTO(desktopAdThreshold),
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval: secondsToMilliseconds(desktopRefreshInterval),
      mediaTypeRefreshers: {
        defaultAttribute: ignoreViewportRefresherAttributes
          ? mediaTypeRefresherToDTO(mediaTypeRefreshers.defaultAttribute)
          : null,
        ignoreViewportRefresherAttributes,
        viewportAttributes: ignoreViewportRefresherAttributes
          ? []
          : mediaTypeRefreshers.viewportAttributes.map(mediaTypeRefresherToDTO),
      },
      mobileAdThreshold: floatPercentToDTO(mobileAdThreshold),
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval: secondsToMilliseconds(mobileRefreshInterval),
      refresherEnabled,
      sendRefreshRequestToExternalAdUnitEnabled,
      ...(sendRefreshRequestToExternalAdUnitEnabled && targetAdUnitPath
        ? { externalAdUnitPath: targetAdUnitPath.trim() }
        : {}),
    }
  })
